import * as React from "react";
import PublishHeader from "./PublishHeader";

const PostSurvey = ({setScreenToShow}) => {
    return (
        <div>
            <PublishHeader
                categorActive={'SURVEY'}
                setScreenToShow={setScreenToShow}
            />
        </div>
    )
}

export default PostSurvey;
